import * as Yup from 'yup';

export const requiredFieldText = 'Campo obrigatório';

export const appointmentSectionSchema = Yup.object().shape({
  attendance_regimen: Yup.string().required(requiredFieldText),
  accident_indication: Yup.string().required(requiredFieldText),
  request_date: Yup.string().required(requiredFieldText),
  tuss_table_code: Yup.string().required(requiredFieldText),
  appointment_value: Yup.string().required(requiredFieldText),
  appointment_type: Yup.string().required(requiredFieldText),
  procedure_code: Yup.string().required(requiredFieldText),
});
